import { WidgetData } from "./Widgets";
import { StudentAssessmentStatus } from "../store/slices/assessmentStatusWidgetSlice";

export type AssessmentStatusWidgetModelInterface = WidgetData & {
  completePercentage: number;
  totalAssessmentCount: number;
  completeCount: number;
  scheduledCount: number;
  inProgressCount: number;
  underReviewCount: number;
  requireActionCount: number;
  students: StudentAssessmentStatus[];
}

export type AssessmentAPIResponseInterface = {
  classroomAssessmentStatusData: {
    data: {
      completePercentage: number;
      totalAssessmentCount: number;
      completeCount: number;
      scheduledCount: number;
      inProgressCount: number;
      underReviewCount: number;
      requireActionCount: number;
      students: StudentAssessmentStatus[];
    }
  }
}

export class AssessmentStatusWidgetModel implements AssessmentStatusWidgetModelInterface {
  [key: string]: unknown;
  private _widgetStatus: string = "none";
  get assessmentWidgetStatus() { return this._widgetStatus };
  set assessmentWidgetStatus(str: string) {this._widgetStatus = str};
  completePercentage: number;
  totalAssessmentCount: number;
  completeCount: number;
  scheduledCount: number;
  inProgressCount: number;
  underReviewCount: number;
  requireActionCount: number;
  students: StudentAssessmentStatus[];

  constructor(statusData: AssessmentAPIResponseInterface) {
    this.completePercentage = statusData?.classroomAssessmentStatusData?.data?.completePercentage as number;
    this.totalAssessmentCount = statusData?.classroomAssessmentStatusData?.data?.totalAssessmentCount as number;
    this.completeCount = statusData?.classroomAssessmentStatusData?.data?.completeCount as number;
    this.scheduledCount = statusData?.classroomAssessmentStatusData?.data?.scheduledCount as number;
    this.inProgressCount = statusData?.classroomAssessmentStatusData?.data?.inProgressCount as number;
    this.underReviewCount = statusData?.classroomAssessmentStatusData?.data?.underReviewCount as number;
    this.requireActionCount = statusData?.classroomAssessmentStatusData?.data?.requireActionCount as number;
    this.students = statusData?.classroomAssessmentStatusData?.data?.students as StudentAssessmentStatus[];
  }
}
